// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__ishiY","link-item":"style_link-item__XkOp3"};